import { combineReducers } from "redux";
import userInfoReducer from "./userInfoReducer";
import userLoginReducer from "./userLoginReducer";
import showNavigationReducer from "./showNavigationReducer";
import fetchGuildListReducer from "./fetchGuildListReducer";
import fetchGuildSingleReducer from "./fetchGuildSingleReducer";
import fetchHealthProtocolsReducer from "./fetchHealthProtocolsReducer";
import fetchProvincesReducer from "./fetchProvincesReducer";
import fetchFlightListReducer from "./fetchFlightListReducer";

const reducers = combineReducers({
  userBasicInfo: userInfoReducer,
  userLoginInfo: userLoginReducer,
  showNavigation: showNavigationReducer,
  guildListLog: fetchGuildListReducer,
  guildSingleLog: fetchGuildSingleReducer,
  healthProtocols: fetchHealthProtocolsReducer,
  provinces: fetchProvincesReducer,
  flightList: fetchFlightListReducer,
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
